module.exports = __webpack_public_path__ + "img/play-error-img-1.65dfb290.png";